import AuthButtons from './AuthButtons'

export default AuthButtons
